import {inject, injectable} from "inversify";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
import {Player} from "@/modules/team/entity";

@injectable()
export default class TerminationFeeCalculator {
  constructor(
    @inject(ConfigRepository) private configRepository: ConfigRepository,
  ) {
  }

  calculate(player: Player): number {
    return this.configRepository.get('players.contract.terminationFee')(player);
  }
}
